<template>
  <div class="item">
    <div class="field-narrow">{{ index + 1 }}</div>
    <div class="field-narrow">{{ index + 1 }}</div>
    <div class="field-medium">{{ item.name }}</div>
    <div class="field-medium">{{ convertToMacAddress(item.MAC) }}</div>
    <div class="field-medium">{{ convertGMT0toGMT8(item.updatetime) }}</div>
    <div class="field-medium" v-if="item.id > 0">
      <button type="button" @click="viewItem" class="btn">{{ $t('information') }}</button>
      <button type="button" @click="editItem" class="btn" v-if="operation && getPermission() < 3">
        {{ $t('edit') }}</button>
      <button type="button" @click="deleteItem" class="btn" v-if="operation && getPermission() < 2">
        {{ $t('delete') }}</button>
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { inject } from 'vue';
import { deleteData } from '../utils/api';
import { checkPages, convertGMT0toGMT8 } from '../utils/stringValid';
import { getPermission } from '../../User';

export default {
  props: {
    index: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    operation: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup() {
    const { t } = useI18n();
    const apiBaseUrl = inject('apiBaseUrl');
    const url = 'device';
    return { t, apiBaseUrl, url };
  },
  methods: {
    convertGMT0toGMT8,
    getPermission,
    checkPages,
    viewItem() {
      this.$router.push(`/${this.url}/${this.item.id}`);
    },
    editItem() {
      this.$router.push(`/${this.url}/edit/${this.item.id}`);
    },
    async deleteItem() {
      try {
        const data = await deleteData(
          this.t,
          `${this.apiBaseUrl}/delete/${this.url}`,
          this.item.id,
        );
        if (data) {
          this.$emit('remove-item', this.item);
        }
      } catch (error) {
        console.error('Error during deletion:', error);
      }
    },
    convertToMacAddress(longInt) {
      const hex = parseInt(longInt, 10).toString(16).padStart(12, '0');
      return hex.replace(/(.{2})(?=.)/g, '$1:').toUpperCase();
    },
  },
};
</script>

<style>
.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: normal;
}

.field-narrow {
  flex: 1;
  text-align: center;
}

.field-medium {
  flex: 2;
  text-align: center;
}
</style>
